import { InputNumber as AntdInputNumber } from 'antd'
import type { InputNumberProps as AntdInputNumberProps } from 'antd'

export interface InputNumberProps extends AntdInputNumberProps {}

export const InputNumber = (props: InputNumberProps) => {
  return <AntdInputNumber {...props} />
}
